<template>
  <div>
    <CCardBody class="py-0 pl-0 pr-0">
      <table class="table mb-0">
        <thead v-show="false">
          <tr>
            <th scope="col">name</th>
            <th scope="col">Cubeta Serie</th>
            <th scope="col">Unidad</th>
          </tr>
        </thead>

        <tbody
          v-for="(r, index) in ubicaciones.filter(
            ubi => ubi.payload.pertenece_id == ubicacionPadre
          )"
          :key="index"
        >
          <tr class="d-table-row pl-2">
            <td
              @click="toggleSubUbicaciones(index)"
              :class="
                `${
                  ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                    .length > 0
                    ? `cursor-p`
                    : ``
                }`
              "
              class="custom-width-name sp-pd"
            >
              <span>
                <CIcon
                  v-if="
                    ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                      .length > 0
                  "
                  name="cil-chevron-circle-down-alt"
                />
              </span>
              {{ r.payload.nombre }}
            </td>

            <td
              @click="toggleSubUbicaciones(index)"
              class="custom-width-name sp-pd"
              :class="
                `${
                  ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                    .length > 0
                    ? `cursor-p`
                    : ``
                }`
              "
            >
              {{ r.total.replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
            </td>

            <td
              @click="toggleSubUbicaciones(index)"
              class="custom-width-name sp-pd"
              :class="
                `${
                  ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                    .length > 0
                    ? `cursor-p`
                    : ``
                }`
              "
            >
              {{ r.unidad }}
            </td>
          </tr>
          <tr
            v-if="
              ubicaciones.filter(p => p.payload.pertenece_id == r.id).length > 0
            "
          >
            <td class="py-0 pl-2 pr-0" colspan="5">
              <CCollapse
                :show="subDetails.includes(index)"
                class="m-0 custom-width-total"
              >
                <table-collapse
                  @click-cancel="toggleCancel"
                  @click-print="printNanoid"
                  :ubicacionPadre="r.id"
                  :cultivos="cultivos"
                  :ubicaciones="ubicaciones"
                ></table-collapse>
              </CCollapse>
            </td>
          </tr>
        </tbody>
      </table>
    </CCardBody>
  </div>
</template>

<script>
export default {
  name: "TableCollapseAnalisis",

  props: {
    ubicaciones: {
      type: Array
    },
    cultivos: {
      type: Array
    },
    ubicacionPadre: {
      type: Number
    }
  },

  data() {
    return {
      subDetails: [],
      itemModal: { id: "", name: "", index: "" }
    };
  },

  components: {
    TableCollapse: () => import("./TableCollapseQuantity.vue")
  },

  methods: {
    toggleCancel(index, item) {
      this.$emit("click-cancel", index, item);
    },
    printNanoid(ubicacion) {
      this.$emit("click-print", ubicacion);
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },

    getCultivo(cultivo_id) {
      const cultivoActual = this.cultivos.find(
        cultivo => cultivo.id == cultivo_id
      );

      return cultivoActual ? cultivoActual.payload.nombre : "";
    },
    toggleSubUbicaciones(index) {
      const positionSub = this.subDetails.indexOf(index);
      positionSub !== -1
        ? this.subDetails.splice(positionSub, 1)
        : this.subDetails.push(index);
    }
  }
};
</script>

<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.sp-pd {
  padding-left: 12px;
  padding-right: 12px;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width-name {
  width: 33% !important;
}
.custom-width {
  width: 17%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100% !important;
}
.cursor-p {
  cursor: pointer;
}
</style>
